import { useEffect, useState, lazy, Suspense } from 'react';
import { WalkingCatLoader } from './component/WalkingCatLoader'
import { useCookies } from 'react-cookie'
import { useDispatch, useSelector } from 'react-redux';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Non-route modules used directly by <Router> stay statically imported.
import { GetRegistration } from './axios/ApiProvider';
import { loginState_Store, authChecked_Store, languageCode_Store } from './store/actions/mainAction';
import { languageStrs_Store } from './store/actions/editAction';
import { editorLangEnStrs } from './lang/editor_string_en';
import { editorLangDeStrs } from './lang/editor_string_de';
import { editorLangFrStrs } from './lang/editor_string_fr';
import { editorLangItStrs } from './lang/editor_string_it';
import { editorLangPtStrs } from './lang/editor_string_pt';
import { editorLangTrStrs } from './lang/editor_string_tr';
import { editorLangEsStrs } from './lang/editor_string_es';
import { Loading } from './component/Loading';
import { useGlobalContext } from './provider';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme/themeProvider";

// Route components are code-split via React.lazy: each becomes its own chunk
// loaded on demand, so visiting "/" no longer downloads the dashboard, editor,
// tools, blogs and careers up front.
const App = lazy(() => import('./pages/App/App').then((m) => ({ default: m.App })));
const SignUp = lazy(() => import('./pages/signUp/signUp').then((m) => ({ default: m.SignUp })));
const SignIn = lazy(() => import('./pages/signIn/signIn').then((m) => ({ default: m.SignIn })));
const Home = lazy(() => import('./pages/Home/Home').then((m) => ({ default: m.Home })));
const Tools = lazy(() => import('./pages/Tools/tools').then((m) => ({ default: m.Tools })));
const SubtitlesTranscription = lazy(() => import('./pages/SubtitlesTranscription/subtitlestranscription').then((m) => ({ default: m.SubtitlesTranscription })));
const PricingPage = lazy(() => import('./pages/Pricing/pricing').then((m) => ({ default: m.PricingPage })));
const ContactUsPage = lazy(() => import('./pages/Contactus/contactus').then((m) => ({ default: m.ContactUsPage })));
const DemoRequestPage = lazy(() => import('./pages/DemoRequest/demorequest').then((m) => ({ default: m.DemoRequestPage })));
const DashBoard = lazy(() => import('./pages/workspaces/workspaces').then((m) => ({ default: m.DashBoard })));
const ProjectView = lazy(() => import('./pages/project-view/projectView').then((m) => ({ default: m.ProjectView })));
const AssetView = lazy(() => import('./pages/asset-view/assetView').then((m) => ({ default: m.AssetView })));
const AIShortView = lazy(() => import('./pages/aishort-view/aishortView'));
const More = lazy(() => import('./pages/More/more').then((m) => ({ default: m.More })));
const AIGenerated = lazy(() => import('./pages/AIGenerated/aigenerated').then((m) => ({ default: m.AIGenerated })));
const VideoEditor = lazy(() => import('./pages/VideoEditor/videoeditor').then((m) => ({ default: m.VideoEditor })));
const VideooBlog = lazy(() => import('./pages/blogs/videooblog/videooblog').then((m) => ({ default: m.VideooBlog })));
const VideooHowto = lazy(() => import('./pages/blogs/videoohowto/videoohowto').then((m) => ({ default: m.VideooHowto })));
const Howto1 = lazy(() => import('./pages/blogs/videoohowto/howto1').then((m) => ({ default: m.Howto1 })));
const Howto2 = lazy(() => import('./pages/blogs/videoohowto/howto2').then((m) => ({ default: m.Howto2 })));
const Blog1 = lazy(() => import('./pages/blogs/videooblog/blog1').then((m) => ({ default: m.Blog1 })));
const Blog2 = lazy(() => import('./pages/blogs/videooblog/blog2').then((m) => ({ default: m.Blog2 })));
const Blog3 = lazy(() => import('./pages/blogs/videooblog/blog3').then((m) => ({ default: m.Blog3 })));
const Blog4 = lazy(() => import('./pages/blogs/videooblog/blog4').then((m) => ({ default: m.Blog4 })));
const Blog5 = lazy(() => import('./pages/blogs/videooblog/blog5').then((m) => ({ default: m.Blog5 })));
const Blog6 = lazy(() => import('./pages/blogs/videooblog/blog6').then((m) => ({ default: m.Blog6 })));
const Blog7 = lazy(() => import('./pages/blogs/videooblog/blog7').then((m) => ({ default: m.Blog7 })));
const Blog8 = lazy(() => import('./pages/blogs/videooblog/blog8').then((m) => ({ default: m.Blog8 })));
const Blog9 = lazy(() => import('./pages/blogs/videooblog/blog9').then((m) => ({ default: m.Blog9 })));
const Blog10 = lazy(() => import('./pages/blogs/videooblog/blog10').then((m) => ({ default: m.Blog10 })));
const Blog11 = lazy(() => import('./pages/blogs/videooblog/blog11').then((m) => ({ default: m.Blog11 })));
const Blog12 = lazy(() => import('./pages/blogs/videooblog/blog12').then((m) => ({ default: m.Blog12 })));
const Blog13 = lazy(() => import('./pages/blogs/videooblog/blog13').then((m) => ({ default: m.Blog13 })));
const Blog14 = lazy(() => import('./pages/blogs/videooblog/blog14').then((m) => ({ default: m.Blog14 })));
const Blog15 = lazy(() => import('./pages/blogs/videooblog/blog15').then((m) => ({ default: m.Blog15 })));
const Blog16 = lazy(() => import('./pages/blogs/videooblog/blog16').then((m) => ({ default: m.Blog16 })));
const Blog17 = lazy(() => import('./pages/blogs/videooblog/blog17').then((m) => ({ default: m.Blog17 })));
const Blog18 = lazy(() => import('./pages/blogs/videooblog/blog18').then((m) => ({ default: m.Blog18 })));
const Career = lazy(() => import('./pages/careers/videoocareer').then((m) => ({ default: m.Career })));
const Career1 = lazy(() => import('./pages/careers/career1').then((m) => ({ default: m.Career1 })));
const Career2 = lazy(() => import('./pages/careers/career2').then((m) => ({ default: m.Career2 })));
const Career3 = lazy(() => import('./pages/careers/career3').then((m) => ({ default: m.Career3 })));
const Career4 = lazy(() => import('./pages/careers/career4').then((m) => ({ default: m.Career4 })));
const Career5 = lazy(() => import('./pages/careers/career5').then((m) => ({ default: m.Career5 })));
const Career6 = lazy(() => import('./pages/careers/career6').then((m) => ({ default: m.Career6 })));
const Career7 = lazy(() => import('./pages/careers/career7').then((m) => ({ default: m.Career7 })));
const Career8 = lazy(() => import('./pages/careers/career8').then((m) => ({ default: m.Career8 })));
const Career9 = lazy(() => import('./pages/careers/career9').then((m) => ({ default: m.Career9 })));
const Career10 = lazy(() => import('./pages/careers/career10').then((m) => ({ default: m.Career10 })));
const NotMatch = lazy(() => import('./pages/notMatch').then((m) => ({ default: m.NotMatch })));
const Terms = lazy(() => import('./pages/terms').then((m) => ({ default: m.Terms })));
const Cookies = lazy(() => import('./pages/cookies').then((m) => ({ default: m.Cookies })));
const Privacy = lazy(() => import('./pages/privacy').then((m) => ({ default: m.Privacy })));
const Security = lazy(() => import('./pages/security').then((m) => ({ default: m.Security })));
const ApiDocs = lazy(() => import('./pages/apidocs').then((m) => ({ default: m.ApiDocs })));
const ConvertVideo = lazy(() => import('./pages/More/convert-video/convert-video').then((m) => ({ default: m.ConvertVideo })));
const CompressVideo = lazy(() => import('./pages/More/compress-video/compress-video').then((m) => ({ default: m.CompressVideo })));
const CropVideo = lazy(() => import('./pages/Tools/crop-video/crop-video').then((m) => ({ default: m.CropVideo })));
const CutVideo = lazy(() => import('./pages/Tools/cut-video/cut-video').then((m) => ({ default: m.CutVideo })));
const JoinMergeVideo = lazy(() => import('./pages/Tools/join-merge-video/join-merge').then((m) => ({ default: m.JoinMergeVideo })));
const LoopVideo = lazy(() => import('./pages/Tools/loop-video/loop-video').then((m) => ({ default: m.LoopVideo })));
const ResizeVideo = lazy(() => import('./pages/Tools/resize-video/resize-video').then((m) => ({ default: m.ResizeVideo })));
const RotateVideo = lazy(() => import('./pages/Tools/rotate-video/rotate-video').then((m) => ({ default: m.RotateVideo })));
const TranscribeVideo = lazy(() => import('./pages/SubtitlesTranscription/transcribe-video/transcribe-video').then((m) => ({ default: m.TranscribeVideo })));
const TranslateVideo = lazy(() => import('./pages/SubtitlesTranscription/translate-video/translate-video').then((m) => ({ default: m.TranslateVideo })));
const AudioToText = lazy(() => import('./pages/SubtitlesTranscription/audio-to-text/audio-to-text').then((m) => ({ default: m.AudioToText })));
const AutoSubtitles = lazy(() => import('./pages/SubtitlesTranscription/auto-subtitles/auto-subtitles').then((m) => ({ default: m.AutoSubtitles })));
const AddSubtitles = lazy(() => import('./pages/SubtitlesTranscription/add-subtitles/add-subtitles').then((m) => ({ default: m.AddSubtitles })));
const AddImageToVideo = lazy(() => import('./pages/VideoEditor/add-image-to-video/add-image-to-video').then((m) => ({ default: m.AddImageToVideo })));
const AddMusicToVideo = lazy(() => import('./pages/VideoEditor/add-music-to-video/add-music-to-video').then((m) => ({ default: m.AddMusicToVideo })));
const AddTextToVideo = lazy(() => import('./pages/VideoEditor/add-text-to-video/add-text-to-video').then((m) => ({ default: m.AddTextToVideo })));
const FilterToVideo = lazy(() => import('./pages/VideoEditor/filter-to-video/filter-to-video').then((m) => ({ default: m.FilterToVideo })));
const AddTransitionstoVideo = lazy(() => import('./pages/VideoEditor/add-transitions-to-video/add-transitions-to-video').then((m) => ({ default: m.AddTransitionstoVideo })));
const AddFreeStockVideo = lazy(() => import('./pages/VideoEditor/add-free-stock-video/add-free-stock-video').then((m) => ({ default: m.AddFreeStockVideo })));
const AIGeneratedVideoSummary = lazy(() => import('./pages/AIGenerated/aigenerated-summary/aigenerated-summary').then((m) => ({ default: m.AIGeneratedVideoSummary })));
const AIGeneratedVideo = lazy(() => import('./pages/AIGenerated/aigenerated-video/aigenerated-video').then((m) => ({ default: m.AIGeneratedVideo })));
const AIGeneratedImage = lazy(() => import('./pages/AIGenerated/aigenerated-image/aigenerated-image').then((m) => ({ default: m.AIGeneratedImage })));
const AIGeneratedVoice = lazy(() => import('./pages/AIGenerated/aigenerated-voice/aigenerated-voice').then((m) => ({ default: m.AIGeneratedVoice })));
const ShareView = lazy(() => import('./pages/asset-view/shareView').then((m) => ({ default: m.ShareView })));
const ShareAIShortView = lazy(() => import('./pages/aishort-view/aishortShareView'));
const AIDubbingView = lazy(() => import('./pages/aidubbing-view/aidubbingView'));
const TranscriptView = lazy(() => import('./pages/transcript-view/transcriptView'));
const JumpCutView = lazy(() => import('./pages/jumpcut-view/jumpcutView'));

const BASE_FRONTEND_EDIT_URL = process.env.REACT_APP_BASE_FRONTEND_EDITOR_URL;

const langPathCodes = [
	'en', 'de', 'tr', 'es', 'it', 'fr', 'pt',
  ];

const CompanyDeactivatedOverlay = ({ userData }) => {
	if (!userData || !userData.company_deactivated) return null;
	return (
		<div style={{
			position: 'fixed', inset: 0, zIndex: 2147483647,
			background: 'rgba(10, 12, 20, 0.92)',
			display: 'flex', alignItems: 'center', justifyContent: 'center',
			padding: '20px',
		}}>
			<div style={{
				maxWidth: 520, width: '100%',
				background: '#ffffff', color: '#1a1a1a',
				borderRadius: 12, padding: '32px 28px',
				boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
				textAlign: 'center', fontFamily: 'system-ui, -apple-system, sans-serif',
			}}>
				<div style={{ fontSize: 20, fontWeight: 600, marginBottom: 12 }}>
					Account deactivated
				</div>
				<div style={{ fontSize: 15, lineHeight: 1.5 }}>
					Your company account is currently deactivated, please contact{' '}
					<a href="mailto:info@kedy.ai" style={{ color: '#0062cc' }}>info@kedy.ai</a>
				</div>
			</div>
		</div>
	);
};

const ProtectedRoute = ({ children }) => {
	const loginState = useSelector((store) => store.maindata.loginState);
	const authChecked = useSelector((store) => store.maindata.authChecked);
	if (!authChecked) return null; // wait for auth check to complete
	if (!loginState) return <Navigate to="/" replace />;
	return children;
};

export const Router = () => {
	const [theme, colorMode] = useMode();
	const dispatch_ = useDispatch();
	const [globalState, { dispatch }] = useGlobalContext()
	const isLoading = useSelector((store) => store.maindata.loading);
	const dataLoaded = useSelector(store => store.webgldata.dataLoaded)
	const languageCode = useSelector(store => store.maindata.languageCode);
	const handleLoaded = () => {

		
		window.dataLayer.push({
			event: 'windowLoaded',
		});

		if(localStorage.getItem('userLocale')){
	
			setLangWithUser(localStorage.getItem('userLocale'));	
		}else{
	
			setLangWithUser(window.navigator.language);
		}
		const routerName = window.location.pathname.split('/');
		const existLangCode = langPathCodes.find(langPItem => langPItem == routerName[1]);
		
		if(routerName[1] !== 'edit'){
			
			setAxiosAuthToken();
		}
		if(routerName[1] == 'edit'){
			window.location = `${BASE_FRONTEND_EDIT_URL}/${routerName[2]}`;
		}

		
	}
	const [basePath, setBasePath] = useState('')

	useEffect(() => {
		window.addEventListener('load', handleLoaded);

		return () => window.removeEventListener('load', handleLoaded);
	}, []);


	useEffect(()=>{
		
		const path = window.location.pathname.split(basePath, '');
		switch(languageCode){
			case 'English':
				setBasePath('/');
				// window.location = '/en'+path;
				break;
			case 'Deutsch':
				setBasePath('/de');
				// window.location = '/de'+path;
				break;
			case 'Türkçe':
				setBasePath('/tr');
				// window.location = '/tr'+path;
				break;
			case 'Espanol':
				setBasePath('/es');
				// window.location = '/es'+path;
				break;
			case 'Italiano':
				setBasePath('/it');
				// window.location = '/it'+path;
				break;
			case 'Français':
				setBasePath('/fr');
				// window.location = '/fr'+path;
				break;
			case 'Portugues':
				setBasePath('/pt');
				// window.location = '/pt'+path;
				break;
			default:
				setBasePath('/');
				// window.location = '/en'+path;
			  	break;
		  }
		//   window.location = basePath+'/'+path;
	}, [languageCode])

	const [cookies, setCookie, removeCookie] = useCookies(['csrftoken']);

	const setAxiosAuthToken = async () => {
		let expires = new Date();
		localStorage.setItem('user_data', null);
		let resultState = await GetRegistration();

		let signed = resultState.state === 'success' && resultState.data['state'].localeCompare('loggedin') === 0;

		if (!!signed) {
			dispatch({ type: 'userData', payload: resultState.data })
      		// setLangWithUser(resultState.data.locale)

			dispatch_(loginState_Store(true))
			expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000);
			setCookie('csrftoken', resultState.data.token, { path: '/', expires });
			localStorage.setItem('userLocale', resultState.data.locale);
			localStorage.setItem('user_data', JSON.stringify(resultState.data));
		} else {
			removeCookie('csrftoken', { path: '/', expires })
		}
		dispatch_(authChecked_Store(true));
	};

	const setLangWithUser = (langCode) => {
		const langStamp = langCode.split('-')[0];

		switch(langStamp){
			case 'en':
				dispatch(languageStrs_Store(editorLangEnStrs));
				dispatch(languageCode_Store('English'));
				break;
			case 'de':
				dispatch(languageStrs_Store(editorLangDeStrs));
				dispatch(languageCode_Store('Deutsch'));
				break;
			case 'tr':
				dispatch(languageStrs_Store(editorLangTrStrs));
				dispatch(languageCode_Store('Türkçe'));
				break;
			case 'es':
				dispatch(languageStrs_Store(editorLangEsStrs));
				dispatch(languageCode_Store('Espanol'));
				break;
			case 'it':
				dispatch(languageStrs_Store(editorLangItStrs));
				dispatch(languageCode_Store('Italiano'));
				break;
			case 'fr':
				dispatch(languageStrs_Store(editorLangFrStrs));
				dispatch(languageCode_Store('Français'));
				break;
			case 'pt':
				dispatch(languageStrs_Store(editorLangPtStrs));
				dispatch(languageCode_Store('Portugues'));
				break;
			default:
			  dispatch(languageStrs_Store(editorLangEnStrs));
			  dispatch(languageCode_Store('English'));
			  break;
		}
	}

	return (
		<ColorModeContext.Provider value={colorMode}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<BrowserRouter basename={basePath}>
					<Suspense fallback={<div className='projects-loading'><WalkingCatLoader /></div>}>
					<Routes >
						<Route path='*' element={<NotMatch />}/>
						<Route path="/signup" element={<SignUp />} />
						<Route path="/signin" element={<SignIn />} />

						<Route path="/video-editor" element={<VideoEditor />} />
						<Route path="/add-subtitles-to-video" element={<AddSubtitles />} />
						<Route path="/add-image-to-video" element={<AddImageToVideo />} />
						<Route path="/add-music-to-video" element={<AddMusicToVideo />} />
						<Route path="/add-text-to-video" element={<AddTextToVideo />} />
						<Route path="/video-filters" element={<FilterToVideo />} />
						<Route path="/add-transition-to-video" element={<AddTransitionstoVideo />} />
						<Route path="/add-free-stock-to-video" element={<AddFreeStockVideo />} />
						
						<Route path="/subtitlestranscription/*" element={<SubtitlesTranscription />} />
					
						<Route path="/tools/*" element={<Tools />} />
						<Route path="/video-converter" element={<ConvertVideo />} />
						<Route path="/video-compressor" element={<CompressVideo />} />
						<Route path="/crop-video" element={<CropVideo />} />
						<Route path="/video-trimmer" element={<CutVideo />} />
						<Route path="/merge-videos" element={<JoinMergeVideo />} />
						<Route path="/loop-video" element={<LoopVideo />} />
						<Route path="/video-resizer" element={<ResizeVideo />} />
						<Route path="/rotate-video" element={<RotateVideo />} />
						<Route path="/transcribe-video-to-text" element={<TranscribeVideo />} />
						<Route path="/video-translator" element={<TranslateVideo />} />
						<Route path="/audio-to-text" element={<AudioToText />} />
						<Route path="/subtitle-generator" element={<AutoSubtitles />} />
						
						<Route path="/more/*" element={<More />} />

						<Route path="/ai-tools/*" element={<AIGenerated />} />
						<Route path="/ai-summary-generator" element={<AIGeneratedVideoSummary />} />
						<Route path="/ai-video-generator" element={<AIGeneratedVideo />} />
						<Route path="/ai-image-generator" element={<AIGeneratedImage />} />
						<Route path="/ai-voice-generator" element={<AIGeneratedVoice />} />

						<Route path="/pricing" element={<PricingPage />} />
						<Route path="/contactus" element={<ContactUsPage />} />
						<Route path="/demo-request" element={<DemoRequestPage />} />
						{/* <Route path="/workspaces/*" element={<DashBoard />} /> */}
						<Route path="/dashboard/*" element={<ProtectedRoute><DashBoard /></ProtectedRoute>} />
						{/* <Route path="/edit/:projectUUID" element={<VideoEditCotainer />} /> */}
						<Route path="/view/:projectUUID/:uuid" element={<ProjectView />} />
						{/* <Route path="/view/:projectUUID/:uuid" element={<AssetView />} /> */}
						<Route path="/asset/view/:uuid" element={<AssetView hasProject={true} />} />
						<Route path="/asset/view/:uuid/:projectUUID" element={<AssetView hasProject={true} />} />

						<Route path="/share/:uuid" element={<ShareView hasProject={false} />} />
						<Route path="/share/aishort/:uuid" element={<ShareAIShortView hasProject={false} />} />
						<Route path="/share/aidubbing/:uuid" element={<AIDubbingView />} />
						<Route path="/share/transcript/:uuid" element={<TranscriptView />} />
						<Route path="/share/jumpcut/:uuid" element={<JumpCutView />} />

						{/* kedy-welcome (static) now owns the site root, so these public app
						    routes are also exposed under /dashboard. kedy-welcome's web.config
						    302-redirects root /share/* /view/* /asset/* /aishort/* here; the
						    router uses basename '/', so the full /dashboard/... path matches.
						    The specific routes below out-rank the protected /dashboard/* splat. */}
						<Route path="/dashboard/share/:uuid" element={<ShareView hasProject={false} />} />
						<Route path="/dashboard/share/aishort/:uuid" element={<ShareAIShortView hasProject={false} />} />
						<Route path="/dashboard/share/aidubbing/:uuid" element={<AIDubbingView />} />
						<Route path="/dashboard/share/transcript/:uuid" element={<TranscriptView />} />
						<Route path="/dashboard/share/jumpcut/:uuid" element={<JumpCutView />} />
						<Route path="/dashboard/view/:projectUUID/:uuid" element={<ProjectView />} />
						<Route path="/dashboard/asset/view/:uuid" element={<AssetView hasProject={true} />} />
						<Route path="/dashboard/asset/view/:uuid/:projectUUID" element={<AssetView hasProject={true} />} />
						<Route path="/dashboard/aishort/:uuid/view" element={<AIShortView hasProject={false} />} />

						{/* <Route path="/view/:aishortUUID/:uuid" element={<AIShortView />} /> */}
						<Route path="/aishort/:uuid/view" element={<AIShortView hasProject={false} />} />

						<Route path="/videooblog" element={<VideooBlog />} />
						<Route path="gm/videooblog" element={<VideooBlog />} />

						<Route path="/videoohowto" element={<VideooHowto />} />
						<Route path="/videoohowto/step-by-step-guide-to-using-ai-based-auto-subtitles-on-videooio" element={<Howto1 />} />
						<Route path="/videoohowto/step-by-step-guide-to-using-ai-based-auto-subtitles-on-videooio" element={<Howto2 />} />

						<Route path="/videooblog/top-online-video-editors-features-pros-cons-pricing" element={<Blog1 />} />
						<Route path="/videooblog/how-did-we-develop-videoo-io-cloud-based-video-editor" element={<Blog2 />} />
						<Route path="/videooblog/cloud-based-vs-consumer-device-video-editors" element={<Blog3 />} />
						<Route path="/videooblog/creating-engaging-social-media-content-guide-videoo-io" element={<Blog4 />} />
						<Route path="/videooblog/online-cloud-video-editors-and-cloud-storage-solution" element={<Blog5 />} />
						<Route path="/videooblog/engaging-different-demographics-on-social-media-guide-videoo-io" element={<Blog6 />} />
						<Route path="/videooblog/how-to-add-auto-subtitles-videoo-io-video-editor" element={<Blog7 />} />
						<Route path="/videooblog/auto-translated-subtitles-videos-videoo-io-editor" element={<Blog8 />} />
						<Route path="/videooblog/cloud-based-video-editors-impact-on-social-media" element={<Blog9 />} />
						<Route path="/videooblog/cloud-based-video-editors-impact-seo" element={<Blog10 />} />
						<Route path="/videooblog/using-cloud-video-editors-increase-social-media-followers" element={<Blog11 />} />
						<Route path="/videooblog/using-videoo-io-increase-social-media-followers" element={<Blog12 />} />
						<Route path="/videooblog/videoo-io-cloud-based-video-editor-every-browser-os" element={<Blog13 />} />
						<Route path="/videooblog/videoo-io-versatile-cloud-based-editor-multiple-platforms" element={<Blog14 />} />
						<Route path="/videooblog/videoo-io-online-cloud-video-editor-development-journey" element={<Blog15 />} />
						<Route path="/videooblog/top-20-cloud-based-online-video-editors" element={<Blog16 />} />
						<Route path="/videooblog/kedyai-vs-opusclip" element={<Blog17 />} />
						<Route path="/videooblog/how-to-use-kedy-ai-to-generate-viral-clips-in-a-single-click" element={<Blog18 />} />

						<Route path="/careers/frontend-software-engineer-videoo" element={<Career1 />} />
						<Route path="/careers/graduate-digital-designer-videoo" element={<Career2 />} />
						<Route path="/careers/cpp-software-developer-opengl-videoo" element={<Career3 />} />
						<Route path="/careers/cloud-devops-engineer-videoo" element={<Career4 />} />
						<Route path="/careers/cloud-solution-architect-videoo" element={<Career5 />} />
						<Route path="/careers/software-engineer-in-test-videoo" element={<Career6 />} />
						<Route path="/careers/product-owner-videoo" element={<Career7 />} />
						<Route path="/careers/chief-financial-officer-cfo-videoo" element={<Career8 />} />
						<Route path="/careers/backend-software-engineer-videoo" element={<Career9 />} />
						<Route path="/careers/video-producer-online-editor-videoo" element={<Career10 />} />

						<Route path="/terms" element={<Terms />} />
						<Route path="/cookies" element={<Cookies />} />
						<Route path="/privacy" element={<Privacy />} />
						<Route path="/security" element={<Security />} />
						<Route path="/documents/api" element={<ApiDocs />} />
						<Route path="/videoocareers" element={<Career />} />

						<Route path="/app" element={<App />} />
						<Route path='/signout' element={<App />}/>
						<Route path="/" element={<Home />} />
						
					</Routes>
					</Suspense>

					<Loading show={globalState.loading} opacity={0.7} />

					{(isLoading || !dataLoaded) && (
						<div className='projects-loading'>
							<WalkingCatLoader />
						</div>
					)}

					<CompanyDeactivatedOverlay userData={globalState.userData} />
				</BrowserRouter>
			</ThemeProvider>
		</ColorModeContext.Provider>
	)
}